import type { CmdbUpsellPageStoreAction } from '../../types.tsx';
import { dismissPage } from '../dismiss-page/index.tsx';
import { enablePage } from '../enable-page/index.tsx';

export const toggleShowPage =
	(): CmdbUpsellPageStoreAction =>
	async ({ getState, dispatch }) => {
		const { userHasDismissed } = getState();
		if (userHasDismissed) {
			dispatch(enablePage());
		} else if (userHasDismissed === false) {
			dispatch(dismissPage());
		}
	};
